import React from "react";

// MUI
import SvgIcon from '@mui/material/SvgIcon';

// Types
import { SvgIconProps } from "@mui/material";

function DomIcon(props: SvgIconProps) {
  return <SvgIcon {...props} >
    <svg version="1.1" id="DomIcon" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      width="100px" height="100px" viewBox="0 0 100 100"
      style={{
        // @ts-ignore
        enableBackground: "new 0 0 100 100"
      }}
      xmlSpace="preserve">
      <path fillRule="evenodd" clipRule="evenodd" fill="currentcolor" d="M17.6,79.9v-4.7h5V46.7h-6.5v-2L50,18l33.9,26.8v2h-6.5v28.4h5v4.7
	C82.4,79.9,17.6,79.9,17.6,79.9z M29.6,50.7h9v12h-9C29.6,62.7,29.6,50.7,29.6,50.7z M61.5,50.7h9v12h-9V50.7z M44.3,75.1h11.5V57.7
	H44.3V75.1z"/>
    </svg>
  </SvgIcon>
}

export default DomIcon;
